import React, { ReactElement, useState, useEffect } from "react";
import Book from "./Book";
import { AccommodationIcon } from "../accommodation/AccommodationIcon.tsx";
import { BOOK_DATE_FORMAT } from "./BookConstant.ts";
import format from "date-fns/format";

interface BookListProps {
    token: string;
    books: Array<Book>;
    //onCancel: () => void;
}

export const BookList: React.FC<BookListProps> = ({ books, token }) => {
    const [contents, setContents] = useState<Array<ReactElement> | null>(null);

    useEffect(() => {
        const content_array: Array<ReactElement> = books.map((book) => {
            return (
                <div className="mail-list-item">
                    <div className="w80 accommodation">
                        {book.accommodation_id ? (
                            <AccommodationIcon
                                token={token}
                                id={book.accommodation_id}
                            />
                        ) : null}
                    </div>
                    <div className="w130">
                        {format(book.start_date, BOOK_DATE_FORMAT)}
                    </div>
                    <div className="free">{book.name}</div>
                    <div className="w100 wide-hidden">
                        {book.person_number}人
                    </div>
                    <div className="w100 wide-hidden">
                        {book.price.toLocaleString()}円
                    </div>
                    <div className="w130">
                        {format(book.created_at, BOOK_DATE_FORMAT)}
                    </div>
                    <div className="w130 ">
                        {book.payment_limit_date
                            ? format(book.payment_limit_date, BOOK_DATE_FORMAT)
                            : "-"}
                    </div>
                    <div className="button wide-hidden"></div>
                </div>
            );
        });
        setContents(content_array);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <>
            <div className="item-list-item header">
                <div className="w80 accommodation">施設</div>
                <div className="w130">宿泊日</div>
                <div className="free">宿泊者</div>
                <div className="w100 wide-hidden">宿泊人数</div>
                <div className="w100 wide-hidden">支払い金額</div>
                <div className="w130">予約発生日</div>
                <div className="w130 ">振込期限</div>
                <div className="button wide-hidden"></div>
            </div>
            <div className="scrollable-container">{contents}</div>
        </>
    );
};
